// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__dhTp-","dark":"Section_dark__LOGiw"};